export default __webpack_public_path__ + "static/media/73_photo.179f3ffb.jpg";